import { PaymentMethod } from '../CommonTypes';

export type TabsComponentProps = {
  onClick: (tabs: PaymentMethod) => void;
  selectedTab: PaymentMethod;
  hideMonthly: boolean;
};

const TabsComponent = ({
  onClick,
  selectedTab,
  hideMonthly
}: TabsComponentProps): JSX.Element => {
  return (
    <div className='payment-tabs'>
      <ul className='nav nav-tabs'>
        <li className='nav-item'>
          <a
            className={`nav-link ${selectedTab === PaymentMethod.annually ? 'active' : ''}`}
            onClick={() => onClick(PaymentMethod.annually)}>
            Pay Annually
          </a>
        </li>
        {!hideMonthly && (
          <li className='nav-item'>
            <a
              className={`nav-link ${selectedTab === PaymentMethod.monthly ? 'active' : ''}`}
              onClick={() => onClick(PaymentMethod.monthly)}>
              Pay Monthly
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default TabsComponent;
